import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getStudents, getStudentById } from '../store/slices/studentsSlice';

export const useStudents = (branchId, placeId) => {
  const dispatch = useDispatch();
  const [students, setStudents] = useState([]);
  const { loading, selectedStudent } = useSelector((state) => state.students);

  const fetchStudents = () => {
    if (!branchId) {
      setStudents([]);
      return;
    }
    
    dispatch(getStudents({ branchId, placeId })).unwrap()
      .then((data) => {
        setStudents(data?.items || data || []);
      })
      .catch(() => {
        setStudents([]);
      });
  };

  const fetchStudentById = (id) => {
    return dispatch(getStudentById(id));
  };

  useEffect(() => {
    fetchStudents();
  }, [dispatch, branchId, placeId]);

  return {
    students,
    selectedStudent,
    loading,
    refetchStudents: fetchStudents,
    fetchStudentById
  };
}; 